import { render } from "./UnsupportedView.vue?vue&type=template&id=0f8de1b6"
import script from "./UnsupportedView.vue?vue&type=script&lang=js"
export * from "./UnsupportedView.vue?vue&type=script&lang=js"

import "./UnsupportedView.vue?vue&type=style&index=0&id=0f8de1b6&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__